import React from 'react'
import { connect } from 'react-redux'
import { MinimalButton } from '@bikemap/components/MinimalButton'
import { gettext } from '@bikemap/js/services'
import { updatePrimaryFilters } from '../../actions'

const t = {
    RESET: gettext('Remove this filter'),
}

/**
 * Message about primary filters.
 * @param {Object} props
 * @param {import("../../reducer").PrimarySearchFiltersState} props.primaryFilters All current primary filters
 * @param {() => void} props.onReset Reset handler for primary filters
 */
const PrimaryFiltersMessage = ({ primaryFilters, onReset }) => {
    const { relativeAscent, relativeDescent } = primaryFilters

    let searchObject
    if (relativeAscent && relativeDescent) {
        const [minAsc, maxAsc] = relativeAscent
        const [minDesc, maxDesc] = relativeDescent
        if (minAsc === 0 && maxAsc < 100) {
            if (minDesc === 0 && maxDesc < 100) {
                searchObject = gettext('flat routes')
            } else if (minDesc > 0 && maxDesc === 100) {
                searchObject = gettext('downhill routes')
            }
        } else if (minAsc > 0 && maxAsc === 100) {
            if (minDesc > 0 && maxDesc === 100) {
                searchObject = gettext('hilly routes')
            } else if (minDesc === 0 && maxDesc < 100) {
                searchObject = gettext('uphill routes')
            }
        } else {
            searchObject = gettext('routes with {minAsc} - {maxAsc} {percent} ascent and {minDesc} - {maxDesc} {percent} descent')
                .replace('{minAsc}', '' + minAsc)
                .replace('{maxAsc}', '' + maxAsc)
                .replace('{minDesc}', '' + minDesc)
                .replace('{maxDesc}', '' + maxDesc)
                .replaceAll('{percent}', '%')
        }
    } else if (relativeAscent) {
        searchObject = gettext('routes with {min} - {max} {percent} ascent')
            .replace('{min}', '' + relativeAscent[0])
            .replace('{max}', '' + relativeAscent[1])
            .replaceAll('{percent}', '%')
    } else if (relativeDescent) {
        searchObject = gettext('routes with {min} - {max} {percent} descent')
            .replace('{min}', '' + relativeDescent[0])
            .replace('{max}', '' + relativeDescent[1])
            .replaceAll('{percent}', '%')
    } else {
        searchObject = gettext('routes')
    }

    const message = gettext('Search all {object}.').replace('{object}', searchObject)

    return (
        <div className="message-box">
            {message} <MinimalButton align onClick={onReset}>{t.RESET}</MinimalButton>
        </div>
    )
}

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ primaryFilters }) => ({
    primaryFilters,
})

const mapDispatchToProps = dispatch => ({
    onReset: () => dispatch(updatePrimaryFilters()),
})

export default connect(mapStateToProps, mapDispatchToProps)(PrimaryFiltersMessage)
